export default "__VITE_ASSET__wE_KLSwu__"